import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import WelcomeScreen from './WelcomeScreen';
import SplitScreen from './SplitScreen';

const Container = styled.div`
  width: 100%;
  height: ${window.innerHeight}px;
  overflow: hidden;
`;

const Home = () => {
  const [ enter, setEnter ] = useState(false);

  const enterSite = () => {
    setEnter(true);
  };

  const backToWelcome = (e: React.MouseEvent) => {
    setEnter(false);
    e.stopPropagation();
  };

  return (
    <Container>
      <WelcomeScreen enter={enter} enterSite={enterSite}/>
      <SplitScreen enter={enter} backToWelcome={backToWelcome}/>
    </Container>
  );
};

export default Home;